import React, { forwardRef } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grow,
  IconButton,
  Typography,
} from '@mui/material'
import { motion } from 'framer-motion'
import { useModal } from 'components/modals'
import { Close } from '@mui/icons-material'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function FallbackModal({
  onClose,
  title = 'The PARCO team is here to help!',
  content = 'Schedule a meeting and one of our teammates will walk you through the process.',
  buttonText = 'Schedule Appointment',
  buttonColor = '#2370ED',
  buttonHoverColor = '#1c59bd',
  cancelButtonText = '',
  showAction = true,
  actionOverride,
}) {
  const { openModal } = useModal()
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{ sx: { overflow: 'visible' } }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <Box
            sx={{
              justifyContent: 'space-between',
              position: 'relative',
              top: -64,
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 0,
                right: -16,
                color: '#fff',
                zIndex: 1,
                backgroundColor: '#000',
                '&:hover': {
                  backgroundColor: '#000',
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Box p={3}>
            <Box>
              <Typography variant="headerTitle" sx={{ color: '#262627' }}>
                {title}
              </Typography>
            </Box>
            <Typography variant="body1" mt={3}>
              {content}
            </Typography>
            <Box display="flex" justifyContent="space-between" mt={3}>
              <Button
                rel="noreferrer"
                size="large"
                variant="contained"
                onClick={onClose}
                sx={{
                  padding: '8px 24px',
                  backgroundColor: '#FFF',
                  border: '2px solid #262627',
                  color: '#262627',
                  boxShadow: 'none',
                  borderRadius: '100px',
                  textTransform: 'capitalize',
                  fontWeight: 600,
                  fontSize: '18px',
                  lineHeight: 1.5,
                  '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                    transform: 'none',
                    backgroundColor: '#f1f1f1',
                    borderColor: '#262627',
                    boxShadow: 'none',
                  },
                  '&:disabled': {
                    borderColor: 'rgba(0,0,0,0)',
                  },
                }}
              >
                {cancelButtonText !== ''
                  ? cancelButtonText
                  : showAction
                  ? 'Cancel'
                  : 'Close'}
              </Button>
              {showAction && (
                <Button
                  rel="noreferrer"
                  size="large"
                  variant="contained"
                  onClick={
                    actionOverride
                      ? actionOverride
                      : () => openModal('scheduleAppointment')
                  }
                  sx={{
                    padding: '8px 24px',
                    backgroundColor: buttonColor,
                    border: `2px solid ${buttonColor}`,
                    color: '#fff',
                    boxShadow: 'none',
                    borderRadius: '100px',
                    textTransform: 'capitalize',
                    fontWeight: 600,
                    fontSize: '18px',
                    lineHeight: 1.5,
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      transform: 'none',
                      backgroundColor: buttonHoverColor,
                      borderColor: buttonHoverColor,
                      boxShadow: 'none',
                    },
                    '&:disabled': {
                      borderColor: 'rgba(0,0,0,0)',
                    },
                  }}
                >
                  {buttonText}
                </Button>
              )}
            </Box>
          </Box>
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
